export function EmptyState({ onUpload, loading }: { onUpload: () => void; loading: boolean }) {
  if (loading) {
    return <div className="card p-10 text-center text-sm text-ink-3">Carregando…</div>;
  }
  return (
    <div className="card flex flex-col items-center px-8 py-16 text-center">
      <div
        className="mb-5 flex h-14 w-14 items-center justify-center rounded-full"
        style={{ background: 'var(--accent-soft)' }}
      >
        <svg viewBox="0 0 24 24" width="26" height="26" fill="none">
          <path
            d="M12 16V4m0 0L7 9m5-5l5 5M5 20h14"
            stroke="var(--accent-bright)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <h2 className="text-lg font-semibold text-ink">Suba sua primeira base</h2>
      <p className="mt-2 max-w-md text-sm text-ink-3">
        Planilha (.xlsx, .xls) ou CSV. O agente lê tudo, mapeia as colunas sozinho e organiza a
        carteira, mesmo que o arquivo esteja bagunçado.
      </p>
      <button className="btn btn-primary mt-6" onClick={onUpload}>
        Selecionar planilha
      </button>
    </div>
  );
}
